interface BannerProps {
  name: string;
  uiClass: string;
}

function Banner({ name, uiClass }: BannerProps) {
  return (
    <>
      <div className={uiClass}>
        <div className="container">
          <h1>{name}</h1>
        </div>
      </div>
    </>
  );
}

export default Banner;
